import React from 'react';
import { useTranslation } from 'react-i18next';
import UserLink from '../User/Link/UserLink';
export const License = ({ license ='none' , publishedTime , author , showSymbol =true  })=>{
    const { t  } = useTranslation();
    const publishedYear = publishedTime && new Date(publishedTime).getFullYear();
    const currentYear = new Date().getFullYear();
    const years = !publishedYear || publishedYear === currentYear ? currentYear : `${publishedYear} - ${currentYear}`;
    if (license === 'none') {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, ` © ${years} `, author && /*#__PURE__*/ React.createElement(UserLink, {
            user: author,
            showSymbol: showSymbol
        }));
    }
    return /*#__PURE__*/ React.createElement("a", {
        rel: "license noopener noreferrer",
        target: "_blank",
        href: `http://creativecommons.org/licenses/${license}/3.0/`
    }, t(`deviation.details.license.${license}`));
};
License.displayName = 'License';
export default License;
